import React, { useState } from 'react';
import { _ as _taggedTemplateLiteralLoose } from './taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';
import { textSizes } from '@growth/design-system';
import { InputField } from '../input-feild/dist/growth-form-controls-input-feild.esm.js';

var _templateObject$1, _templateObject2, _templateObject3;
var fullViewStyle = "\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100vh;\n\tborder-radius: 0;\n\toverflow: scroll;\n";
var Wrap = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 310px;\n\theight: 225px;\n\tborder-radius: 8px;\n\tbackground: #fff;\n\tpadding: 15px;\n\tbox-shadow: rgba(0, 0, 0, 0.2) -5px 0px 9px 0px;\n\tz-index: 1024;\n\t", "\n"])), function (props) {
  return props.fullView ? fullViewStyle : '';
});
var Header = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #222222;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 20px;\n\n\t& .close {\n\t\tposition: relative;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\topacity: 0.9;\n\t\tmargin-right: 10px;\n\t}\n\t& .close:before,\n\t& .close:after {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\tcontent: ' ';\n\t\theight: 20px;\n\t\twidth: 2px;\n\t\tbackground-color: #333;\n\t}\n\t& .close:before {\n\t\ttransform: rotate(45deg);\n\t}\n\t& .close:after {\n\t\ttransform: rotate(-45deg);\n\t}\n"])), textSizes.LargeW2);
var Title = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tcolor: #b0b0b0;\n\tmargin: 10px 0;\n"])));

var _templateObject;
var List$1 = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tlist-style-type: none;\n\tpadding: 0;\n\tmargin: 0;\n\toverflow: hidden;\n\toverflow-y: auto;\n"])));

var List = function List(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/React.createElement(List$1, null, options.map(function (option) {
    return option;
  }));
};

var Dropdown = function Dropdown(props) {
  var _props$showSearchFiel = props.showSearchField,
    showSearchField = _props$showSearchFiel === void 0 ? false : _props$showSearchFiel,
    _props$fullView = props.fullView,
    fullView = _props$fullView === void 0 ? false : _props$fullView,
    options = props.options,
    handleInputSearch = props.handleInputSearch,
    heading = props.heading,
    listTitle = props.listTitle,
    handleDropDownClose = props.handleDropDownClose,
    searchFieldPlaceholder = props.searchFieldPlaceholder,
    bodyCompoment = props.bodyCompoment;
  var _useState = useState(''),
    inputSearchValue = _useState[0],
    setInputSearchValue = _useState[1];
  var handleInputFieldSearch = function handleInputFieldSearch(value) {
    setInputSearchValue(value);
    handleInputSearch == null || handleInputSearch(value);
  };
  return /*#__PURE__*/React.createElement(Wrap, {
    fullView: fullView
  }, fullView && /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement("span", {
    role: "presentation",
    className: "close",
    onClick: handleDropDownClose
  }), heading), showSearchField ? /*#__PURE__*/React.createElement(InputField, {
    fullView: fullView,
    value: inputSearchValue,
    placeholder: searchFieldPlaceholder || '',
    onChange: handleInputFieldSearch,
    inputWrapStyle: {
      boxShadow: 'unset'
    }
  }) : null, listTitle ? /*#__PURE__*/React.createElement(Title, null, listTitle) : null, bodyCompoment || options && /*#__PURE__*/React.createElement(List, {
    options: options
  }));
};
Dropdown.defaultProps = {
  fullView: false,
  handleInputSearch: undefined,
  showSearchField: false,
  handleDropDownClose: undefined,
  heading: '',
  searchFieldPlaceholder: '',
  bodyCompoment: null,
  options: []
};

export { Dropdown as D, List as L };
